import React from 'react';
import DesignSummary from '../designSummary/index';

// The Calling Desk is the Design Summary table with a call button in place of
// every Value column - see the `callingDesk` prop in pages/designSummary.
const CallingDesk = (props) => <DesignSummary {...props} callingDesk />;

export default CallingDesk;
